import { getCurrentUser } from "aws-amplify/auth";

export const getUserLocale = (): string => {
    return navigator.language || navigator.languages[0] || 'en-US';
};

export const getCurrentDateTime = (locale: string): string => {
    const currentDate = new Date();
    return new Intl.DateTimeFormat(locale, {
        dateStyle: 'full', // Customize the format as per your need
        timeStyle: 'short',
    }).format(currentDate);
};

export const getUserEmail = async () => {
    try {
        const session = await getCurrentUser();
        return session.signInDetails?.loginId;
    } catch (error) {
        throw error;
    }
};